import {useState, useEffect} from 'react'
import {Form, Input, Modal,Button, notification, Spin,Select } from 'antd';
import {Row,Col} from 'react-bootstrap';

const { Option } = Select;

const PlanCutomizModel = ({onCancel, isModalOpen, tableId}) => {

  const [form] = Form.useForm();
  const [userName, setUserName] = useState('');
  const [userDomin, setUserDomin] = useState("")
  const [domainId, setDomainId] = useState(null)
  const [initialId, setInitialId] = useState(null)
  const [userEmail, setUserEmail] = useState('');
  const [userPhoneNumber, setUserPhoneNumber] = useState('');
  const [userCompany, setUserCompany] = useState('');
  const [teamStrength, setTeamStrength] = useState('');
  const [companyLocation, setCompanyLocation] = useState('');
  const [companyStartDate, setCompanyStartDate] = useState(null);
  const [gmbProfileUrl, setGmbProfileUrl] = useState('');
  const [planAmount, setPlanAmount] = useState('')
  const [taxAmount, setTaxAmount] = useState('')
  const [credits, setCredits] = useState('')
  const [notes, setNotes]= useState('')
  const [companyCountry, setCompanyCountry] = useState(""); // Stores country
  const [companyState, setCompanyState] = useState([]); 
  const [showData, setShowData] = useState(null)
  const [loading, setLoading] = useState(false)


  const fetchGetById = async (tableId) => {
    try {
      const response = await fetch(`https://euctostaging.com/lmsca/api/businessinitialform/showwithId/${tableId}`);
      if (response.ok) {
        const result = await response.json();
        const parsedState = JSON.parse(result.state || "[]");
        setShowData(result);  // Store the result
        setCompanyCountry(result.country)
        setCompanyState(parsedState)
        setUserDomin(result.categoryName);// Set the category value to `userDomin` 
        setUserEmail(result.email)
        setUserPhoneNumber(result.number)
        setUserCompany(result.brand_name)
        setUserName(result.name)
        setDomainId(result.category) 
        setInitialId(result.id)

        form.setFieldsValue({
          fullName: result.name,
          email: result.email,
          phoneNumber: result.number,
          companyName: result.brand_name, 
          domainName: result.categoryName,
          domainId: result.category,
          initialId:result.id,
        });
      } else {
        const errorData = await response.json();
        notification.error({
          message: 'Opps!',
          description: errorData.message || 'Team, please enter the details manually.',
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);  // Log the actual error
      notification.error({
        message: 'Error',
        description: `Something went wrong while fetching data. Error: ${error.message}`,
      });
    }
  };
  
  useEffect(() => {
    if (tableId) {
      fetchGetById(tableId);
    }
  }, [tableId]);

  const handleSignup = async () => {
    const formData = {
      name: userName,
      email: userEmail,
      mobileNo: userPhoneNumber,
      companyName: userCompany,
      teamStrength: teamStrength,
      location: companyLocation,
      startDate: companyStartDate,
      gmbProfileUrl: gmbProfileUrl,
      country:companyCountry,
      state:companyState,
      jobsPerDay: teamStrength, //SKIP THIS
      category: domainId,
      initialUserId:initialId,
    };

    try {
      const response = await fetch(`https://apicanada.blaccdot.com/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const responseData = await response.json();
        const userId = responseData?.data?.userId; // Extract `userId` from `data`
        if (userId) {
          localStorage.setItem('signUpId', userId);
          notification.success({
            message: 'Success',
            description: 'User signup successfully!',
          });
        }
      } else {
        const errorData = await response.json();
        console.log(errorData,"error data")
        localStorage.setItem('signUpId', errorData?.data?.userId);
        if(errorData?.message == "User already exists"){
          notification.warning({
            message: errorData?.message,
            description: "You can proceed to next process."
          })
        }else{
        notification.error({
          message: 'Opps!',
          description: errorData.message || 'An unexpected error occurred.',
        });
      }
      }
    } catch (error) {
      notification.error({
        message: 'Opps!',
        description: 'Got error from Server',
      });
    }
  };
  
  const handleCustomPlan = async () => {
      const userID = parseInt(localStorage.getItem('signUpId'), 10);
      const token = localStorage.getItem('accessToken');
      
      const payload = {
        userId:userID,
        provinceId: companyState,
        title: 'Custom Subscription',
        amount: planAmount,
        taxAmount: taxAmount,
        creditpoints: credits,
        category: domainId,
        currency:"GBP",
        // country:companyCountry,
        country: 1,
        //state:companyState,
        textcontent: {
          description1: notes,
        },
      };
  
      try {
        const response = await fetch(`https://apicanada.blaccdot.com/masters/customplan/create`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization:`${token}`,
          },
          body: JSON.stringify(payload),
        });
  
        if (response.ok) {
          const jsonResponse = await response.json();
    
          const { data } = jsonResponse; // Extract the data key
          if (!data) {
            throw new Error('Missing data in response');
          }
    
          // Save relevant response data to localStorage
          localStorage.setItem('userId', data.userId);
          localStorage.setItem('amount', data.amount);
          localStorage.setItem('taxAmount', data.taxAmount);
          localStorage.setItem('creditpoints', data.creditpoints);
          localStorage.setItem('CustommasterId', data.CustommasterId);
          notification.open({
            // message: 'Plan Created Successfully!',
            description: (
              <div
                style={{
                  padding: '10px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '5px',
                  backgroundColor: '#fbfbfb',
                }} >
                <h4 style={{ marginBottom: '10px', fontWeight: 'bold', color: '#595959' }}>Confirm Details</h4>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                  <span>Amount:</span>
                  <span style={{ fontWeight: 'bold' }}>$ {payload.amount}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                  <span>Tax Amount:</span>
                  <span style={{ fontWeight: 'bold' }}>$ {payload.taxAmount}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                  <span>Number of Credits:</span>
                  <span style={{ fontWeight: 'bold', color: '#3f8600' }}>{payload.creditpoints}</span>
                </div>
              </div>
            ),
            duration: 0,
            btn: (
              <Spin spinning={loading} indicator={<Spin />} size="small">
          <Button type="primary" onClick={handleSendPaymentLink}
            disabled={loading}>
            {loading ? 'Sending Payment Link' : 'Send Payment Link'}
          </Button>
        </Spin>
            //   <Button
            //   type="primary"
            //   onClick={handleSendPaymentLink}
            //   loading={setLoading(true)}>
            //   Send Payment Link
            // </Button>
            
            ),style: { position: 'relative' },
            // closeIcon: <span style={{ display: 'none' }} />,
          });
           onCancel()
        } else {
          const errorData = await response.json();
          notification.error({
            message: 'Oops!',
            description: errorData.message || 'An unexpected error occurred.',
          });
        }
      } catch (error) {
        notification.error({
          message: 'Oops!',
          description: 'An error occurred while creating the plan.',
        });
      }
  };


  const handleSendPaymentLink = async () => {
    const token = localStorage.getItem('accessToken');
    const userId = parseInt(localStorage.getItem('userId'), 10);
    const amount = parseInt(localStorage.getItem('amount'), 10);
    const creditpoints = parseInt(localStorage.getItem('creditpoints'), 10);
    const taxAmount = parseInt(localStorage.getItem('taxAmount'), 10)
    const subscriptionID = parseInt(localStorage.getItem('CustommasterId'), 10);
  
    setLoading(true); 
  
    try {
      const response = await fetch(`https://apicanada.blaccdot.com/campaign/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          plantype: 'custom',
          userId: userId,
          subscriptionId: subscriptionID,
          country:companyCountry,
          provinceId: companyState,
          longDistanceLeads: true,
          taxAmount:taxAmount,
          amount: amount,
          credit: creditpoints,
          category: domainId,
        }),
      });
  
      if (response.ok) {
        notification.success({
          message: 'Payment Link Sent!',
          description: 'The payment link has been successfully sent to the user.',
        });
       // notification.destroy(); // Close notificatio
      } else {
        const errorData = await response.json();
        notification.error({
          message: 'Error',
          description: errorData.message || 'Failed to send the payment link.',
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'An error occurred while sending the payment link.',
      });
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };
  
  

  return (
    <div>
       <Modal  open={isModalOpen} onCancel={onCancel} closable={false} centered width={1000} footer={null}>
          <Row>
              <Col md={6}>
                       <Form layout="vertical" form={form}>
                         <h5>Signup process</h5><hr />
                         <Form.Item label="Domain" name="domainName">
                            <Input size="large" value={userDomin} disabled />
                      </Form.Item>
                         <Form.Item label="Full Name" name="fullName"
                           rules={[{ required: true, message: 'Please Enter full name' }]}>
                           <Input size="large" value={userName} onChange={(e) => setUserName(e.target.value)} />
                         </Form.Item>
                         <Form.Item name="email" label="Business EmailID"
                           rules={[{ required: true, message: 'Please Enter Email!' }]} >
                           <Input size="large" value={userEmail} onChange={(e) => setUserEmail(e.target.value)} />
                         </Form.Item>
                         <Form.Item name="phoneNumber" label="Business Phone number"
                           rules={[{ required: true, message: 'Please Enter Phone number!' }]} >
                           <Input size="large" value={userPhoneNumber} onChange={(e) => setUserPhoneNumber(e.target.value)} />
                         </Form.Item>
                         <Form.Item name="companyName" label="Company Name"
                           rules={[{ required: true, message: 'Please Enter Company Name!' }]} >
                           <Input size="large" value={userCompany} onChange={(e) => setUserCompany(e.target.value)} />
                         </Form.Item>
                         <Form.Item name="teamStength" label="Team strength" 
                           rules={[{ required: true, message: 'Please Enter Team strength!' }]} >
                           <Input type="number" size="large" value={teamStrength} onChange={(e) => setTeamStrength(e.target.value)} />
                         </Form.Item>
                         <Form.Item name="location" label="Company Location"
                           rules={[{ required: true, message: 'Please Enter Location!' }]} >
                           <Input size="large" value={companyLocation} onChange={(e) => setCompanyLocation(e.target.value)} />
                         </Form.Item>
                         <Form.Item name="startName" label="Company Start Date"
                           rules={[{ required: true, message: 'Please Enter Date!' }]} >
                           <Input size="large" type="date" value={companyStartDate}
                             onChange={(e) => setCompanyStartDate(e.target.value)} />
                         </Form.Item>
                         <Form.Item name="GMBURL" label="GMB Profile URL"
                           rules={[{ required: true, message: 'Please Enter GMB Profile URL!' }]} >
                           <Input size="large" value={gmbProfileUrl} onChange={(e) => setGmbProfileUrl(e.target.value)} />
                         </Form.Item>
                         <Form.Item style={{ paddingTop: '15px' }}>
                           <Button onClick={handleSignup} style={{ height: '40px', width: '100%' }} type="primary" htmlType="submit" block>
                             Sign up
                           </Button>
                         </Form.Item>
                       </Form>
              </Col>

            <Col md={6}>
        <Form layout="vertical" initialValues={{ planname: 'Custom Subscription' }}>
          <h5>Customize the Plan</h5>
          <hr/>
          <Form.Item name="planname" label="Plan Name (Title)"
            rules={[{ required: true, message: 'Please input your Plan Name!' }]} >
            <Input size="large" disabled value="Custom Subscription" />
          </Form.Item>
          <Form.Item name="planAmount" label="Plan Amount"
            rules={[{ required: true, message: 'Please input your Plan Amount!' }]}>
            <Input size="large" value={planAmount} onChange={(e) => setPlanAmount(e.target.value)}/>
          </Form.Item>
          <Form.Item name="planTax" label="Plan Tax Amount"
            rules={[{ required: true, message: 'Please input your Plan Tax Amount!' }]}>
            <Input size="large" value={taxAmount} onChange={(e) => setTaxAmount(e.target.value)}/>
          </Form.Item>
          <Form.Item name="credit" label="Number of Credits" rules={[{ required: true, message: 'Please input your Credits!' }]} >
            <Input size="large" value={credits} onChange={(e) => setCredits(e.target.value)} />
          </Form.Item>
          <Form.Item name="notes" label="Notes" 
          rules={[{ required: true, message: 'Please input your Notes!' }]}>
            <Input size="large" value={notes} onChange={(e) => setNotes(e.target.value)}/>
          </Form.Item>
          <Form.Item style={{ paddingTop: '15px' }}>
            <Button onClick={handleCustomPlan}  style={{ height: '40px', width: '100%' }}type="primary" block>
              Create Plan
            </Button>
          </Form.Item>
        </Form>
            </Col>


          </Row>
      </Modal>
    </div>
  )
}

export default PlanCutomizModel




// import React,{useState, useEffect} from 'react'
// import {Form, Input, Modal,Button, notification, Spin } from 'antd';
// import {Row,Col} from 'react-bootstrap';



// const PlanCutomizModel = ({onCancel, isModalOpen, tableId}) => {

//   const [form] = Form.useForm();
//   const [userName, setUserName] = useState('');
//   const [userEmail, setUserEmail] = useState('');
//   const [userPhoneNumber, setUserPhoneNumber] = useState('');
//   const [userCompany, setUserCompany] = useState('');
//   const [teamStrength, setTeamStrength] = useState('');
//   const [companyLocation, setCompanyLocation] = useState('');
//   const [companyStartDate, setCompanyStartDate] = useState(null);
//   const [gmbProfileUrl, setGmbProfileUrl] = useState('');
//   const [planTitle, setPlanTitle] = useState('')
//   const [planAmount, setPlanAmount] = useState('')
//   const [taxAmount, setTaxAmount] = useState('')
//   const [credits, setCredits] = useState('')
//   const [notes, setNotes]= useState('')
//   const [showData, setShowData] = useState(null)

//   const fetchGetById = async (tableId) => {
//     try {
//       const response = await fetch(`https://euctostaging.com/lmsca/api/businessinitialform/showwithId/${tableId}`);
//       if (response.ok) {
//         const result = await response.json();
//         console.log('result GetbyID', result)
//         setShowData(result);  // Store the result
//         form.setFieldsValue({
//           fullName: result.name,
//           email: result.email,
//           phoneNumber: result.number,
//           companyName: result.brand_name, 
//         });
//       } else {
//         const errorData = await response.json();
//         notification.error({
//           message: 'Opps!',
//           description: errorData.message || 'Team, please enter the details manually.',
//         });
//       }
//     } catch (error) {
//       console.error('Error fetching data:', error);  // Log the actual error
//       notification.error({
//         message: 'Error',
//         description: `Something went wrong while fetching data. Error: ${error.message}`,
//       });
//     }
//   };
  
//   useEffect(() => {
//     if (tableId) {
//       fetchGetById(tableId);
//     }
//   }, [tableId]);


//   const handleSignup = async () => {
//     const formData = {
//       name: userName,
//       email: userEmail,
//       mobileNo: userPhoneNumber,
//       companyName: userCompany,
//       teamStrength: teamStrength,
//       location: companyLocation,
//       startDate: companyStartDate,
//       gmbProfileUrl: gmbProfileUrl,
//       jobsPerDay: teamStrength, //SKIP THIS
//     };

//     try {
//       const response = await fetch(`https://apicanada.blaccdot.com/auth/register`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });
//       if (response.ok) {
//         const responseData = await response.json();
//         const userId = responseData?.data?.userId; // Extract `userId` from `data`
//         if (userId) {
//           localStorage.setItem('signUpId', userId);
//           notification.success({
//             message: 'Success',
//             description: 'User signup successfully!',
//           });
//         }
//       } else {
//         const errorData = await response.json();
//         notification.error({
//           message: 'Opps!',
//           description: errorData.message || 'An unexpected error occurred.',
//         });
//       }
//     } catch (error) {
//       notification.error({
//         message: 'Opps!',
//         description: 'Got error from Server',
//       });
//     }
//   };

//     const handleCustomPlan = async () => {
//       const userID = parseInt(localStorage.getItem('signUpId'), 10);
//       const token = localStorage.getItem('accessToken');
      
//       const payload = {
//         userId:userID,
//         // plantype:'Custom',
//         provinceId: 1,
//         title: 'Custom Subscription',
//         amount: planAmount,
//         taxAmount: taxAmount,
//         creditpoints: credits,
//         textcontent: {
//           description1: notes,
//         },
//       };
  
//       try {
//         const response = await fetch(`https://apicanada.blaccdot.com/masters/customplan/create`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization:`${token}`,
//           },
//           body: JSON.stringify(payload),
//         });
  
//         if (response.ok) {
//           const data = await response.json();
//           notification.success({
//             message: 'Success',
//             description: 'Plan created successfully!',
//           });
//           onCancel()
//         } else {
//           const errorData = await response.json();
//           notification.error({
//             message: 'Oops!',
//             description: errorData.message || 'An unexpected error occurred.',
//           });
//         }
//       } catch (error) {
//         notification.error({
//           message: 'Oops!',
//           description: 'An error occurred while creating the plan.',
//         });
//       }
//     };


//   return (
//     <div>
//        <Modal  open={isModalOpen} onCancel={onCancel} closable={false} centered width={1000} footer={null}>
//           <Row>
//               <Col md={6}>
//                        <Form layout="vertical" form={form}>
//                          <h5>Signup process</h5><hr />
//                          <Form.Item label="Full Name" name="fullName"
//                            rules={[{ required: true, message: 'Please Enter full name' }]}>
//                            <Input size="large" value={userName} onChange={(e) => setUserName(e.target.value)} />
//                          </Form.Item>
//                          <Form.Item name="email" label="Business EmailID"
//                            rules={[{ required: true, message: 'Please Enter Email!' }]} >
//                            <Input size="large" value={userEmail} onChange={(e) => setUserEmail(e.target.value)} />
//                          </Form.Item>
//                          <Form.Item name="phoneNumber" label="Business Phone number"
//                            rules={[{ required: true, message: 'Please Enter Phone number!' }]} >
//                            <Input size="large" value={userPhoneNumber} onChange={(e) => setUserPhoneNumber(e.target.value)} />
//                          </Form.Item>
//                          <Form.Item name="companyName" label="Company Name"
//                            rules={[{ required: true, message: 'Please Enter Company Name!' }]} >
//                            <Input size="large" value={userCompany} onChange={(e) => setUserCompany(e.target.value)} />
//                          </Form.Item>
//                          <Form.Item name="teamStength" label="Team strength"
//                            rules={[{ required: true, message: 'Please Enter Team strength!' }]} >
//                            <Input size="large" value={teamStrength} onChange={(e) => setTeamStrength(e.target.value)} />
//                          </Form.Item>
//                          <Form.Item name="location" label="Company Location"
//                            rules={[{ required: true, message: 'Please Enter Location!' }]} >
//                            <Input size="large" value={companyLocation} onChange={(e) => setCompanyLocation(e.target.value)} />
//                          </Form.Item>
//                          <Form.Item name="startName" label="Company Start Date"
//                            rules={[{ required: true, message: 'Please Enter Date!' }]} >
//                            <Input size="large" type="date" value={companyStartDate}
//                              onChange={(e) => setCompanyStartDate(e.target.value)} />
//                          </Form.Item>
//                          <Form.Item name="GMBURL" label="GMB Profile URL"
//                            rules={[{ required: true, message: 'Please Enter GMB Profile URL!' }]} >
//                            <Input size="large" value={gmbProfileUrl} onChange={(e) => setGmbProfileUrl(e.target.value)} />
//                          </Form.Item>
//                          <Form.Item style={{ paddingTop: '15px' }}>
//                            <Button onClick={handleSignup} style={{ height: '40px', width: '100%' }} type="primary" htmlType="submit" block>
//                              Sign up
//                            </Button>
//                          </Form.Item>
//                        </Form>
//                      </Col>

//             <Col md={6}>
//         <Form layout="vertical" initialValues={{ planname: 'Custom Subscription' }}>
//           <h5>Customize the Plan</h5>
//           <hr/>
//           <Form.Item name="planname" label="Plan Name (Title)"
//             rules={[{ required: true, message: 'Please input your Plan Name!' }]} >
//             <Input size="large" disabled value="Custom Subscription" />
//           </Form.Item>
//           <Form.Item name="planAmount" label="Plan Amount"
//             rules={[{ required: true, message: 'Please input your Plan Amount!' }]}>
//             <Input size="large" value={planAmount} onChange={(e) => setPlanAmount(e.target.value)}/>
//           </Form.Item>
//           <Form.Item name="planTax" label="Plan Tax Amount"
//             rules={[{ required: true, message: 'Please input your Plan Tax Amount!' }]}>
//             <Input size="large" value={taxAmount} onChange={(e) => setTaxAmount(e.target.value)}/>
//           </Form.Item>
//           <Form.Item name="credit" label="Number of Credits" rules={[{ required: true, message: 'Please input your Credits!' }]} >
//             <Input size="large" value={credits} onChange={(e) => setCredits(e.target.value)} />
//           </Form.Item>
//           <Form.Item name="notes" label="Notes" 
//           rules={[{ required: true, message: 'Please input your Notes!' }]}>
//             <Input size="large" value={notes} onChange={(e) => setNotes(e.target.value)}/>
//           </Form.Item>
//           <Form.Item style={{ paddingTop: '15px' }}>
//             <Button onClick={handleCustomPlan}  style={{ height: '40px', width: '100%' }}type="primary" block>
//               Create Plan
//             </Button>
//           </Form.Item>
//         </Form>
//             </Col>
//           </Row>
 
//       </Modal>
//     </div>
//   )
// }

// export default PlanCutomizModel
